import { config } from "@common/utils/config";
import { styled } from "@givenwell/stitches";
import { colors } from "@givenwell/theme";

type Environment = (typeof config)["environmentName"];
type Position = { top?: number; right?: number; left?: number };

type EnvironmentBadgeProps = { environmentName: Environment; isDev: boolean; position: Position };
export function EnvironmentBadge(props: EnvironmentBadgeProps) {
  if (!props.isDev) return null;

  return (
    <BadgeDiv
      css={{
        ...props.position,
        backgroundColor: BADGE_COLORS[props.environmentName],
      }}
    >
      {config.environmentName.toUpperCase()}
    </BadgeDiv>
  );
}

const BadgeDiv = styled("div", {
  position: "absolute",
  color: colors.white,
  padding: "1px 4px",
  rounded: 4,
  fontScale: "xs",
  fontWeight: 600,
  transform: "rotate(3.14159deg)",
});

const BADGE_COLORS: Record<Environment, string | undefined> = {
  dev: undefined,
  test: colors.green500,
  demo: colors.red300,
  prod: colors.red500,
};
